import axios from 'axios';

class ConfigService {
  constructor() {
    this.config = null;
  }

  async initialize() {
    if (this.config) return this.config;
    try {
      // Fetches runtime configuration as described in README.md
      const response = await axios.get('/config/runtime-config.json');
      this.config = response.data || {};
      return this.config;
    } catch (error) {
      console.warn('ConfigService: Failed to fetch runtime config, using defaults.', error);
      this.config = {};
      return this.config;
    }
  }

  get(key, defaultValue = undefined) {
    if (!this.config) {
      return defaultValue;
    }
    return this.config[key] !== undefined ? this.config[key] : defaultValue;
  }

  getAll() {
    return this.config ? { ...this.config } : {};
  }
}

export default new ConfigService();

